package com.shadowings.gero.util

import androidx.compose.runtime.Composable
import androidx.compose.ui.hapticfeedback.HapticFeedback
import androidx.compose.ui.hapticfeedback.HapticFeedbackType

object HapticVibrationManager {
    var isEnabled: Boolean = true
}

class ToggleableHapticFeedback(
    private val delegate: HapticFeedback,
    private val isEnabled: () -> Boolean
) : HapticFeedback {
    override fun performHapticFeedback(hapticFeedbackType: HapticFeedbackType) {
        if (isEnabled()) {
            delegate.performHapticFeedback(hapticFeedbackType)
        }
    }
}

@Composable
expect fun rememberHapticVibration(): (durationMs: Long) -> Unit

